(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["petfu-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Announcement bar auto-slide ── */
  var slides = document.querySelectorAll('.pf-announce-slide');
  if (slides.length > 1) {
    var current = 0;
    var annTimer;

    function annGoTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].classList.add('is-exit');
      var prev = current;
      current = (index + slides.length) % slides.length;
      setTimeout(function () { slides[prev].classList.remove('is-exit'); }, 420);
      slides[current].classList.add('is-active');
    }

    function annStart() { annTimer = setInterval(function () { annGoTo(current + 1); }, 4000); }
    function annStop()  { clearInterval(annTimer); }

    annStart();

    var prevBtn = document.querySelector('[data-pf-ann-prev]');
    var nextBtn = document.querySelector('[data-pf-ann-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { annStop(); annGoTo(current - 1); annStart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { annStop(); annGoTo(current + 1); annStart(); });

    var bar = document.querySelector('.pf-announce-bar');
    if (bar) {
      bar.addEventListener('mouseenter', annStop);
      bar.addEventListener('mouseleave', annStart);
    }
  }

  /* ── Shop mega menu open/close ── */
  var shopNavTrigger = document.querySelector('[data-pf-shopnav-trigger]');
  var shopNav        = document.querySelector('[data-pf-shopnav]');
  var overlay        = document.querySelector('[data-pf-page-overlay]');

  function openShopNav()  { if (!shopNav) return; shopNav.classList.add('is-open'); shopNav.setAttribute('aria-hidden','false'); if (shopNavTrigger) shopNavTrigger.setAttribute('aria-expanded','true'); if (overlay) overlay.classList.add('is-visible'); }
  function closeShopNav() { if (!shopNav) return; shopNav.classList.remove('is-open'); shopNav.setAttribute('aria-hidden','true'); if (shopNavTrigger) shopNavTrigger.setAttribute('aria-expanded','false'); if (overlay) overlay.classList.remove('is-visible'); }

  var shopNavLeaveTimer;

  if (shopNavTrigger) {
    shopNavTrigger.addEventListener('mouseenter', function () { clearTimeout(shopNavLeaveTimer); openShopNav(); });
    shopNavTrigger.addEventListener('click', function () { shopNav && shopNav.classList.contains('is-open') ? closeShopNav() : openShopNav(); });
  }
  if (overlay) overlay.addEventListener('click', function () { closeShopNav(); closeMobile(); closeDrawers(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeShopNav(); closeMobile(); closeDrawers(); } });

  var header = document.querySelector('[data-pf-header]');
  if (header && shopNav) {
    [header, shopNav].forEach(function (el) {
      el.addEventListener('mouseleave', function () { shopNavLeaveTimer = setTimeout(closeShopNav, 200); });
      el.addEventListener('mouseenter', function () { clearTimeout(shopNavLeaveTimer); });
    });
  }

  document.addEventListener('click', function (e) {
    var aboutMenu = document.querySelector('.pf-about-menu');
    if (aboutMenu && aboutMenu.open && !aboutMenu.contains(e.target)) aboutMenu.open = false;
  });

  /* ── Mobile nav ── */
  var mobilePanel = document.querySelector('[data-pf-mobile-panel]');
  function openMobile()  { if (!mobilePanel) return; mobilePanel.setAttribute('aria-hidden','false'); mobilePanel.classList.add('is-open'); if (overlay) overlay.classList.add('is-visible'); document.body.style.overflow = 'hidden'; }
  function closeMobile() { if (!mobilePanel) return; mobilePanel.setAttribute('aria-hidden','true'); mobilePanel.classList.remove('is-open'); if (!document.querySelector('.pf-side-drawer[aria-hidden="false"]')) { if (overlay) overlay.classList.remove('is-visible'); } document.body.style.overflow = ''; }

  var mobileOpen  = document.querySelector('[data-pf-mobile-open]');
  var mobileClose = document.querySelector('[data-pf-mobile-close]');
  if (mobileOpen)  mobileOpen.addEventListener('click', openMobile);
  if (mobileClose) mobileClose.addEventListener('click', closeMobile);

  /* ── Drawers ── */
  function openDrawer(drawer) { if (!drawer) return; drawer.setAttribute('aria-hidden','false'); if (overlay) overlay.classList.add('is-visible'); document.body.style.overflow = 'hidden'; }
  function closeDrawers() { document.querySelectorAll('.pf-side-drawer').forEach(function (d) { d.setAttribute('aria-hidden','true'); }); if (!mobilePanel || !mobilePanel.classList.contains('is-open')) { if (overlay) overlay.classList.remove('is-visible'); } document.body.style.overflow = ''; }

  var cartOpen = document.querySelector('[data-pf-cart-open]');
  if (cartOpen) {
    cartOpen.addEventListener('click', function(e) {
      e.preventDefault();
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          openCartDrawer(cart);
        });
    });
  }

  var searchOpen   = document.querySelector('[data-pf-search-open]');
  var searchDrawer = document.querySelector('[data-pf-search-drawer]');
  if (searchOpen && searchDrawer) searchOpen.addEventListener('click', function (e) { e.preventDefault(); openDrawer(searchDrawer); var input = searchDrawer.querySelector('[data-pf-search-input]'); if (input) setTimeout(function () { input.focus(); }, 100); });

  document.querySelectorAll('[data-pf-drawer-close]').forEach(function (btn) { btn.addEventListener('click', closeDrawers); });

  /* ── Search ── */
  var searchInput   = document.querySelector('[data-pf-search-input]');
  var searchResults = document.querySelector('[data-pf-search-results]');
  var searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = '<p>Start typing to find a treat.</p>'; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            if (!products.length) { searchResults.innerHTML = '<p>No results found for "' + q + '".</p>'; return; }
            searchResults.innerHTML = products.map(function (p) {
              return '<a href="' + p.url + '" style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid rgba(61,44,30,0.08);text-decoration:none;color:inherit;">' +
                (p.featured_image ? '<img src="' + p.featured_image + '" width="48" height="48" style="object-fit:contain;border-radius:6px;flex-shrink:0;">' : '') +
                '<div><b style="display:block;font-size:14px;color:#3D2C1E;">' + p.title + '</b></div></a>';
            }).join('');
          })
          .catch(function () { searchResults.innerHTML = '<p>Search unavailable. Please try again.</p>'; });
      }, 300);
    });
  }

  /* ── Cart count ── */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
    document.querySelectorAll('[data-pf-cart-count]').forEach(function (el) { el.textContent = data.item_count || ''; });
  });
  /* ── Open cart drawer after bundle add ── */
  /* ── Cart drawer render + open ── */
  var cartDrawer = document.querySelector('[data-pf-cart-drawer]');
  var cartContent = document.querySelector('[data-pf-cart-content]');

  function renderCartDrawer(cart) {
    if (!cartContent) return;

    if (!cart || cart.item_count === 0) {
      cartContent.innerHTML =
        '<div style="text-align:center;padding:60px 20px;">' +
          '<p style="font-size:15px;color:#8A6A50;margin-bottom:20px;">Your cart is feeling peckish.</p>' +
          '<a href="/collections/all" style="display:inline-block;padding:12px 24px;background:#1e3a2f;color:#fff;border-radius:999px;font-size:13px;font-weight:700;text-decoration:none;text-transform:uppercase;letter-spacing:.06em;">Shop treats →</a>' +
        '</div>';
      return;
    }

    var itemsHtml = cart.items.map(function(item) {
      var imgHtml = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '" width="76" height="76" style="width:76px;height:76px;object-fit:contain;border-radius:8px;" alt="' + item.title + '">'
        : '';
      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="pf-cx-meta">' + item.variant_title + '</span>'
        : '';
      var planHtml = item.selling_plan_allocation
        ? '<span class="pf-cx-meta">' + item.selling_plan_allocation.selling_plan.name + '</span>'
        : '';

      return '<div class="pf-cx-item">' +
        '<div class="pf-cx-thumb">' + imgHtml + '</div>' +
        '<div>' +
          '<div class="pf-cx-head">' +
            '<a class="pf-cx-title" href="' + item.url + '">' + item.product_title + '</a>' +
            '<div class="pf-cx-price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
          variantHtml + planHtml +
          '<div class="pf-cx-foot">' +
            '<div class="pf-cx-qty">' +
              '<button type="button" data-cx-minus data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" ' + (item.quantity <= 1 ? 'disabled' : '') + '>−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cx-plus data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<button class="pf-cx-remove" type="button" data-cx-remove data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('<hr style="border:none;border-top:1px solid rgba(61,44,30,0.08);margin:0 0 20px;">');

    var totalHtml =
      '<div class="pf-cx-footer">' +
        '<div class="pf-cx-total"><span>Total</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
        '<a href="/checkout" class="pf-cx-checkout">Checkout →</a>' +
      '</div>';

    cartContent.innerHTML = itemsHtml + totalHtml;

    // Wire up qty +/- and remove buttons
    cartContent.querySelectorAll('[data-cx-minus],[data-cx-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });
    cartContent.querySelectorAll('[data-cx-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-pf-cart-count]').forEach(function(el) {
      el.textContent = count || '';
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCartDrawer(cart) {
    if (!cartDrawer) return;
    if (cart) renderCartDrawer(cart);
    cartDrawer.setAttribute('aria-hidden', 'false');
    var overlay = document.querySelector('[data-pf-page-overlay]');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  // Listen for bundle builder's cart:refresh event
  document.addEventListener('cart:refresh', function(e) {
    var cart = e.detail;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        openCartDrawer(cart);
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petfu-product"] && !Shopify.designMode) return;
  try {
    
/* =========================================================
   PETFU Product Page — JavaScript
   Handles:
     1. Thumbnail gallery swap
     2. Variant select → price + ATC update
     3. Subscription / one-time purchase toggle
     4. Scroll-reveal (.pf-reveal)
   ========================================================= */

(function () {
  'use strict';

  /* ── 1. Gallery Auto-Slider ── */
  function initGallery() {
    var track     = document.getElementById('pf-gallery-track');
    var thumbs    = document.querySelectorAll('[data-pf-thumb-index]');
    var prevBtn   = document.querySelector('.pf-gallery-prev');
    var nextBtn   = document.querySelector('.pf-gallery-next');
    if (!track) return;

    var total     = track.children.length;
    var current   = 0;
    var autoTimer = null;
    var AUTO_MS   = 3500; // auto-advance every 3.5 seconds

    function goTo(index) {
      // Wrap around
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      // Sync thumbnails
      thumbs.forEach(function (t) {
        var isActive = parseInt(t.dataset.pfThumbIndex, 10) === current;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        // Scroll only the thumbnail strip — never the whole page
        if (isActive) {
          var row = t.parentElement;
          if (row) {
            row.scrollLeft = t.offsetLeft - (row.offsetWidth / 2) + (t.offsetWidth / 2);
          }
        }
      });
    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(function () { goTo(current + 1); }, AUTO_MS);
    }

    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    // Thumbnail clicks
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        stopAuto();
        goTo(parseInt(t.dataset.pfThumbIndex, 10));
        startAuto();
      });
    });

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAuto();
        goTo(current - 1);
        startAuto();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAuto();
        goTo(current + 1);
        startAuto();
      });
    }

    // Touch / swipe support
    var touchStartX = 0;
    track.parentElement.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.parentElement.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        stopAuto();
        goTo(diff > 0 ? current + 1 : current - 1);
        startAuto();
      }
    }, { passive: true });

    // Pause on hover
    track.parentElement.addEventListener('mouseenter', stopAuto);
    track.parentElement.addEventListener('mouseleave', startAuto);

    // Init
    goTo(0);
    if (total > 1) startAuto();
  }

  /* ── 2. Variant Select ── */
  function initVariantSelect() {
    const variantSelect   = document.querySelector('[data-pf-variant-select]');
    const priceEl         = document.querySelector('[data-pf-purchase-price]');
    const pointsEl        = document.querySelector('[data-pf-order-points]');
    const pointsValueEl   = document.querySelector('[data-pf-order-points-value]');
    const atcBtn          = document.querySelector('[data-pf-product-form] .pf-button');

    if (!variantSelect) return;

    variantSelect.addEventListener('change', function () {
      const selected  = variantSelect.options[variantSelect.selectedIndex];
      const price     = selected.dataset && selected.dataset.price;
      const disabled  = selected.disabled;

      // Price display — naive: if Shopify injects the formatted price already
      // we just swap the selected option text's price portion.
      if (priceEl && selected.text) {
        // Extract money portion from "Size · SKU · $XX.XX" pattern
        const match = selected.text.match(/\$[\d,]+\.?\d*/);
        if (match) priceEl.textContent = match[0];
      }

      // ATC button state
      if (atcBtn) {
        if (disabled) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold out';
        } else {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to cart →';
        }
      }

      // Points notice
      if (pointsEl && price) {
        pointsEl.dataset.price = price;
        // Re-evaluate approximate points (10 pts per dollar, assuming $1 = 100 cents)
        const cents = parseInt(price, 10);
        if (!isNaN(cents) && pointsValueEl) {
          const points = Math.floor(cents / 100) * 10;
          pointsValueEl.textContent = points + ' points';
        }
      }
    });
  }

  /* ── 3. Subscription / One-time Toggle ── */
  function initSubscriptionToggle() {
    const planFieldset     = document.querySelector('[data-pf-plan-fieldset]');
    if (!planFieldset) return;

    const modeRadios       = planFieldset.querySelectorAll('[name="pf_purchase_mode"]');
    const modeCards        = planFieldset.querySelectorAll('.pf-purchase-mode-card');
    const planSelect       = planFieldset.querySelector('[data-pf-selling-plan]');
    const priceEl          = document.querySelector('[data-pf-purchase-price]');

    if (!modeRadios.length || !planSelect) return;

    // Sync active card class
    function syncCards() {
      modeCards.forEach(function (card) {
        const radio = card.querySelector('input[type="radio"]');
        if (radio) {
          card.classList.toggle('is-active', radio.checked);
        }
      });
    }

    modeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncCards();

        if (radio.value === 'subscribe') {
          // Activate first valid subscription plan
          const firstSubOption = planSelect.querySelector('option[value]:not([value=""])');
          if (firstSubOption) {
            planSelect.value = firstSubOption.value;
            if (priceEl && firstSubOption.dataset.price) {
              priceEl.textContent = formatMoney(parseInt(firstSubOption.dataset.price, 10));
            }
          }
          planSelect.closest('.pf-subscription-frequency') &&
            (planSelect.closest('.pf-subscription-frequency').style.display = '');
        } else {
          // One-time: clear selling_plan
          const onceOption = planSelect.querySelector('option[value=""]');
          if (onceOption) {
            planSelect.value = '';
            if (priceEl && onceOption.dataset.price) {
              priceEl.textContent = formatMoney(parseInt(onceOption.dataset.price, 10));
            }
          }
        }
      });
    });

    // Sync on load
    syncCards();
  }

  /* ── Helper: format cents → $XX.XX ── */
  function formatMoney(cents) {
    if (isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ── 4. Scroll Reveal ── */
  function initScrollReveal() {
    const els = document.querySelectorAll('.pf-reveal');
    if (!els.length) return;

    // Respect reduced-motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── 5. Quantity clamp ── */
  function initQuantityClamp() {
    const qtyInput = document.querySelector('[data-pf-purchase-quantity]');
    if (!qtyInput) return;
    qtyInput.addEventListener('change', function () {
      if (parseInt(qtyInput.value, 10) < 1 || isNaN(parseInt(qtyInput.value, 10))) {
        qtyInput.value = 1;
      }
    });
  }

  /* ── Init ── */
  function init() {
    initGallery();
    initVariantSelect();
    initSubscriptionToggle();
    initScrollReveal();
    initQuantityClamp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


  } catch(e) { console.error(e); }
})();
})();
